var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"z-list-item flex space-x-1"},[(_vm.icon)?_c('z-icon',{attrs:{"icon":_vm.icon,"size":_vm.iconSize}}):_vm._e(),_vm._v(" "),_c(_vm.as,_vm._b({tag:"component",class:[_vm.tagSpecificStyles]},'component',_vm.$attrs,false),[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }